import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);

const WALKTHROUGH = "walkthough";
/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
let walkthoughOptions = [
  { id: 1, title: "movie listing and add" },
  { id: 2, title: "schedule : drag and drop" }
];

const WalkthroughService = {
  getWalkthoughComplete(walkthough_id) {
    let walkthrough_complete_status = Vue.localStorage.get(
      `walkthough_${walkthough_id}`
    );
    return !walkthrough_complete_status ||
      walkthrough_complete_status === "start_again"
      ? false
      : true;
  },

  setWalkthroughComplete(walkthough_id) {
    Vue.localStorage.set(`walkthough_${walkthough_id}`, "complete");
  },

  setWalkthroughRestart(walkthough_id) {
    Vue.localStorage.set(`walkthough_${walkthough_id}`, "start_again");
  }
};

export { WalkthroughService };



// WEBPACK FOOTER //
// ./src/local-services/storage.service.js